<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>
          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>
                Avisos que envía el sistema a usuarios o correos.
                Elige qué eventos disparan alertas (p. ej., pedido
                listo, entrega fallida) y por qué canal salen.
                Úsalo para que las personas correctas se enteren
                a tiempo.
              </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Templates
          </h2>
        </div>  
        <div class="text-sm text-secondary font-medium tracking-tight">
          Diseña los <b>templates</b> a usar en las <b>notificaciones</b> dentro de AVE.
        </div>
      </div>
      <!-- Header -->
      <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">

        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <button mat-icon-button color="primary" (click)="openModal()" matTooltip="Nuevo Registro">
            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
          </button>

          <button mat-icon-button color="primary" [matMenuTriggerFor]="filterMenu" matTooltip="Glosario">
            <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
          </button>
          <mat-menu #filterMenu="matMenu">
            <button mat-menu-item [matMenuTriggerFor]="typeMenu">
              <span>Tipo</span>
            </button>
            <button mat-menu-item [matMenuTriggerFor]="priorityMenu">
              <span>Estado</span>
            </button>
          </mat-menu>
          <mat-menu #typeMenu="matMenu">
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_outline:envelope" style="color: #9f9f3d"></mat-icon>
              <span>Email</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_outline:envelope" style="color: #008000;"></mat-icon>
              <span>Whatsapp</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_outline:envelope" style="color: #ffa500;"></mat-icon>
              <span>Notificación</span>
            </button>
          </mat-menu>
          <mat-menu #priorityMenu="matMenu">
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_outline:check-circle" style="color: #28a745;"></mat-icon>
              <span>Activo</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_outline:pencil" style="color: #9e9e9e;"></mat-icon>
              <span>Borrador</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_outline:archive-box" style="color: #607d8b;"></mat-icon>
              <span>Archivado</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>

    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort
              (matSortChange)="changeSort($event)" matSortDisableClear multiTemplateDataRows>

              <ng-container matColumnDef="typeId">
                <th mat-header-cell *matHeaderCellDef class="text-center p-2"></th>
                <td mat-cell *matCellDef="let element" class="text-center p-2">
                  @if(element?.typeId == notificationTypesEnum.NOTIFICATIONS){
                  <button matTooltip="Notificación">
                    <mat-icon svgIcon="heroicons_outline:envelope" style="color: #ffa500;"></mat-icon>
                  </button>
                  }@else if (element?.typeId == notificationTypesEnum.WHATSAPP) {
                  <button matTooltip="Whatsapp">
                    <mat-icon svgIcon="heroicons_outline:envelope" style="color: #008000;"></mat-icon>
                  </button>
                  }@else {
                  <button matTooltip="Email">
                    <mat-icon svgIcon="heroicons_outline:envelope" style="color: #9f9f3d"></mat-icon>
                  </button>
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="statusId">
                <th mat-header-cell *matHeaderCellDef class="text-center p-2"></th>
                <td mat-cell *matCellDef="let element" class="text-center p-2">
                  @if(element?.statusId == notificationTemplateStatusEnum.ACTIVE){
                  <button matTooltip="Activo">
                    <mat-icon svgIcon="heroicons_outline:check-circle" style="color: #28a745;"></mat-icon>
                  </button>
                  }@else if (element?.statusId == notificationTemplateStatusEnum.DRAFT) {
                  <button matTooltip="Borrador">
                    <mat-icon svgIcon="heroicons_outline:pencil" style="color: #9e9e9e;"></mat-icon>
                  </button>
                  }@else {
                  <button matTooltip="Archivado">
                    <mat-icon svgIcon="heroicons_outline:archive-box" style="color: #607d8b;"></mat-icon>
                  </button>
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Título</th>
                <td mat-cell *matCellDef="let element" class="text-sm uppercase">
                  {{ element?.name}}
                </td>
              </ng-container>

              <ng-container matColumnDef="subject">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Asunto</th>
                <td mat-cell *matCellDef="let element" class="text-sm uppercase">
                  {{ element?.subject}}
                </td>
              </ng-container>

              <ng-container matColumnDef="company">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Compañia</th>
                <td mat-cell *matCellDef="let element" class="text-sm uppercase">
                  {{ element?.company.name}}
                </td>
              </ng-container>

              <ng-container matColumnDef="salesOffice">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Oficina</th>
                <td mat-cell *matCellDef="let element" class="text-sm uppercase">
                  {{ element?.salesOffice.name}}
                </td>
              </ng-container>

              <!-- Acciones -->
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                <td mat-cell *matCellDef="let element" class="px-6 py-3 text-left">
                  <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #actionMenu="matMenu">
                    <button mat-menu-item (click)="openModal(element)">
                      <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      <span>Editar Registro</span>
                    </button>
                    <button mat-menu-item (click)="openDeleteDialog(element)">
                      <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      <span>Eliminar Registro</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>

              <!-- Header Row -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"
                class="sticky top-0 z-10 bg-white dark:bg-gray-900">
              </tr>

              <!-- Fila principal -->
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b"></tr>
            </table>
          </div>
          <div *ngIf="this.dataSource.data.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">
            Lo sentimos, no hay registros para mostrar.
          </div>
        </div>

        <!-- Paginación debería asignar valor a this.pageSize-->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
          <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
            [pageSize]="pageSize" (page)="changePage($event)"></mat-paginator>
        </div>
      </div>
    </div>



    <ng-template #actionModal>
    <h2 mat-dialog-title class="text-lg font-bold mb-1">{{ (this.id == null ? 'Nuevo' : 'Editar')}} Registro</h2>
    <mat-dialog-content class="modal-content">
      <form #modalForm="ngForm">

        <div class="grid grid-cols-1 md:grid-cols-2 gap-y-2 gap-x-4">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Tipo</mat-label>
            <mat-select [(ngModel)]="currentTemplate.typeId" name="typeId" required>
              @for (type of listChannel; track type) {
              <mat-option [value]="type">
                {{ getListTypeLabel(type) }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Nombre</mat-label>
            <input matInput [(ngModel)]="currentTemplate.name" name="name"
              oninput="this.value = this.value.toUpperCase()" required>
          </mat-form-field>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-y-2 gap-x-4">
          <mat-form-field appearance="fill">
            <mat-label>Compañía</mat-label>
            <mat-select [(ngModel)]="currentTemplate.companyId" 
                        name="companyId"
                        (selectionChange)="onCompanySelectionChange($event.value)">
              <mat-option value="">Seleccionar compañía</mat-option>
              <mat-option *ngFor="let company of companyList" [value]="company._id">
                {{ company.name }}
              </mat-option>
            </mat-select>
            <mat-hint *ngIf="companyList.length === 0">Cargando compañías...</mat-hint>
          </mat-form-field>

          <mat-form-field appearance="fill" class="w-full">
            <mat-label class="block text-gray-700">Oficina de Venta</mat-label>
            <mat-select [(ngModel)]="currentTemplate.salesOfficeId" 
                        name="salesOfficeId"
                        [disabled]="!currentTemplate.companyId || isLoadingSalesOffices">
              <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchOffice" 
                                    [ngModelOptions]="{standalone: true}"
                                    (ngModelChange)="changueOptionsSalesOffice($event)" 
                                    placeholderLabel="Buscar oficina..."
                                    noEntriesFoundLabel="No se encontraron resultados">
                </ngx-mat-select-search>
              </mat-option>
              
              <mat-option *ngIf="!currentTemplate.companyId" disabled>
                Primero selecciona una compañía
              </mat-option>
              <mat-option *ngIf="currentTemplate.companyId && isLoadingSalesOffices" disabled>
                Cargando oficinas...
              </mat-option>
              <mat-option *ngIf="currentTemplate.companyId && !isLoadingSalesOffices && listFilterSalesOfficeList().length === 0" disabled>
                No hay oficinas disponibles para esta compañía
              </mat-option>
              @for (office of listFilterSalesOfficeList(); track office._id) {
                <mat-option [value]="office._id">
                  <b *ngIf="getCode(office) as code">{{ code }} - </b>{{ office.name }}
                </mat-option>
              }
            </mat-select>
            <mat-hint *ngIf="!currentTemplate.companyId">
              Selecciona primero una compañía
            </mat-hint>
            <mat-hint *ngIf="currentTemplate.companyId && isLoadingSalesOffices">
              Cargando oficinas de ventas...
            </mat-hint>
            <mat-hint *ngIf="currentTemplate.companyId && !isLoadingSalesOffices && salesOfficeList.length > 0">
              {{ salesOfficeList.length }} oficina(s) disponible(s)
            </mat-hint>
          </mat-form-field>
        </div>
          
        <div class="grid grid-cols-1 md:grid-cols-2 gap-y-2 gap-x-4 items-center">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Estado de plantilla </mat-label>
            <mat-select [(ngModel)]="currentTemplate.statusId" name="statusId" required>
              @for (type of listStatus; track type) {
              <mat-option [value]="type">
                {{ getListStatusLabel(type) }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-slide-toggle class="custom-slide-toggle primary mb-2" [(ngModel)]="currentTemplate.isBodyHtml"
            name="isBodyHtml" [color]="'success'">
            {{currentTemplate.isBodyHtml ? 'Con HTML' : 'Sin HTML'}}
          </mat-slide-toggle>
        </div>
        
        <div class="grid grid-cols-1 md:grid-cols-2 gap-y-2 gap-x-4 items-center">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Asunto</mat-label>
            <input matInput [(ngModel)]="currentTemplate.subject" name="subject" required>
          </mat-form-field>

          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Eventos</mat-label>
            <mat-select [(ngModel)]="currentTemplate.eventId" name="event" required>
              @for (type of listEvents; track type) {
              <mat-option [value]="type">
                {{ getListEventLabel(type) }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

      @if(!currentTemplate.isBodyHtml){
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Texto</mat-label>
        <textarea matInput [(ngModel)]="currentTemplate.bodyText" name="bodyText" cdkTextareaAutosize
          #autosize="cdkTextareaAutosize" cdkAutosizeMaxRows="2"></textarea>
      </mat-form-field>
      }@else{
      <quill-editor [(ngModel)]="currentTemplate.bodyHtml" name="bodyHtml" [modules]="quillModules" theme="snow"
        placeholder="Escribe aquí..." (onContentChanged)="onContentChanged($event)">
      </quill-editor>
      }

    </form>
    </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex justify-between">
        <button mat-button mat-dialog-close>Cancelar</button>
        <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!modalForm.valid">Guardar</button>
      </mat-dialog-actions>
    </ng-template>

    <ng-template #deleteDialog let-data>
      <div class="flex items-start space-x-2 mb-4">
        <div class="flex items-center">
          <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
            style="font-size: 32px;"></mat-icon>
        </div>
        <div class="grid">
          <h2 mat-dialog-title class="text-lg font-bold mb-1">Confirmar eliminación</h2>
          <mat-dialog-content class="modal-content mt-0">
            <p>¿Está seguro que desea eliminar el registro?</p>
          </mat-dialog-content>
        </div>
      </div>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close>Conservar</button>
        <button mat-raised-button color="warn" [mat-dialog-close]="true">Eliminar</button>
      </mat-dialog-actions>
    </ng-template>
  </div>
</mat-sidenav-container>